module.exports = __webpack_public_path__ + "img/office-2.2349f22b.png";